import store from '@/store';

export default {
    isCoverPublic(path) {
        const cover_public_exp = /\/(?:covers)\/\w+\/(?:public)/;

        return path.match(cover_public_exp);
    },
    resetData() {
        store.dispatch('user/deleteInfo');
        store.dispatch('system/updateSearchState', 'basic');
        store.dispatch('system/updateSearchStateCovers', 'basic');

        if (
            window.location.pathname != '/login' &&
            window.location.pathname != '/password/forgot' &&
            window.location.pathname != '/password/reset' &&
            !this.isCoverPublic(window.location.pathname)
        ) {
            store.dispatch('system/updateInitialized', false);
        }
    },
};
